import { scaleUtc } from 'd3-scale';
import { useMemo } from 'react';
import { useSvgContext } from '../../context';
import { TIME } from './constants';
import { customDay } from './customInterval';

export default function useScaleTimeX(min: any, max: any, utcOffset: any) {
  const { right, left, width } = useSvgContext();
  return useMemo(() => {
    const interval = customDay(utcOffset);
    const scale: any = scaleUtc()
      .domain([Date.parse(min), Date.parse(max)])
      .range([left, width - right])
      .nice(interval);
    scale.type = TIME;
    scale.interval = interval;
    return scale;
  }, [min, max, utcOffset, right, left, width]);
}
